/**
 * Shown on the loader that holds a screen back until the ATS lookup resolves.
 *
 * Every screen that chooses between an ATS and a non-ATS experience waits on that
 * lookup, and QA measured the wait at 10-18s on a slow connection. A bare spinner
 * for that long reads as stalled, so the wait says what it is for — and says the
 * same thing everywhere, since a recruiter can meet it on several steps of one
 * wizard.
 */
export const ATS_LOOKUP_LOADING_TITLE = 'Checking your ATS connection';
